import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import ContentWrapper from "../../components/Common/ContentWrapper";
import { addressInsideTypeActions } from "../../redux/reducers/addressInsideTypeReducer";
import Grid from "../../components/Grid";
import { Show } from "../../hooks/Show";

const AddressInsideType = ({
  requestStatus,
  reduxResetAddressInsideTypeForm,
  reduxPatchAddressInsideType,
  reduxPostAddressInsideType,
  reduxDeleteAddressInsideType,
  reduxGetAddressInsideType,
  addressInsideTypes,
  reduxGetAddressInsideTypes,
  addressInsideType,
  rowEdited,
  rowDeleted,
  rowUpdated,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [offset, setOffset] = useState(10);
  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData.idAddressInsideType}</span>;
      },
      field: 'idAddressInsideType',
      searchable: true
    },
    {
      title: "Código",
      render: (rowData) => {
        return <span>{rowData.code}</span>;
      },
      field: 'code',
      searchable: true
    },
    {
      title: "Descripción",
      render: (rowData) => {
        return <span>{rowData.name}</span>;
      },
      field: 'name',
      searchable: true
    },
    {
      title: "Opciones",
      render: (rowData) => {
        return (
          <>
            {rowData.isActive ? (
              <>
                <Show when="feature:edit-addressInsideType">
                  <button
                    title="Editar"
                    className="btn btn-primary btn-sm  btn-circle mr-2"
                    type="button"
                    onClick={(e) => handleOpen(rowData)}
                  >
                    <i className="fas fa-edit fa-xs"></i>
                  </button>
                </Show>
                <Show when="feature:disabled-addressInsideType">
                  <button
                    title="Desactivar"
                    className="btn btn-danger btn-sm btn-circle"
                    type="button"
                    onClick={(e) => handleDelete(rowData)}
                  >
                    <i className="fas fa-times-circle fa-xs"></i>
                  </button>
                </Show>
              </>
            ) : (
              <Show when="feature:enabled-addressInsideType">
                <button
                  title="Activar"
                  className="btn btn-primary btn-sm  btn-circle mr-2"
                  type="button"
                  onClick={(e) => handleActive(rowData)}
                >
                  <i className="fas fa-check-circle fa-xs"></i>
                </button>
              </Show>
            )}
          </>
        );
      },
    },
  ];
  const handleClose = () => {
    reduxResetAddressInsideTypeForm();
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const onSubmit = (data) => {
    if (rowEdited) {
      reduxPatchAddressInsideType({
        ...data,
        id: rowEdited.idAddressInsideType,
      });
    } else {
      reduxPostAddressInsideType({ ...data, id: data.name, code: data.name });
    }
    reset();
    reduxResetAddressInsideTypeForm();
    setShow(false);
  };
  const handleOpen = (row) => {
    reduxGetAddressInsideType({
      id: row.idAddressInsideType,
    });
  };

  const handleActive = (row) => {
    if (!row.isActive) {
      reduxDeleteAddressInsideType(row);
    }
  };

  const handleDelete = (row) => {
    reduxDeleteAddressInsideType(row);
  };
  useEffect(() => {
    reduxGetAddressInsideTypes({
      page: 1,
      offset: offset,
      search: "",
    });
  }, []);

  useEffect(() => {
    if (rowEdited) {
      setShow(true);
      setValue("name", rowEdited.name);
      setValue("code", rowEdited.code);
    }
  }, [rowEdited]);

  useEffect(() => {
    reduxGetAddressInsideTypes({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage]);

  useEffect(() => {
    if (addressInsideType || rowUpdated || rowDeleted) {
      reduxGetAddressInsideTypes({
        page: currentPage,
        offset: offset,
        search: search,
      });
      reduxResetAddressInsideTypeForm();
    }
  }, [addressInsideType, rowUpdated, rowDeleted]);

  return (
    <ContentWrapper>
      <div className="d-sm-flex align-items-center mb-1">
        <h1 className="h3 mb-0 text-gray-800 mr-3"> Tipo de Interior</h1>
        <Show when="feature:create-addressInsideType">
          <button
            className="btn btn-primary btn-circle"
            type="button"
            onClick={handleShow}
          >
            <i className="fas fa-plus fa-sm"></i>
          </button>
        </Show>
      </div>
      <p className="mb-4">Tipos de Interior</p>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Tipos de Interior
          </h6>
        </div>
        <div className="card-body">
          <Grid
            cols={columns}
            data={
              addressInsideTypes && Object.keys(addressInsideTypes).length > 0
                ? addressInsideTypes.items
                : []
            }
            page={
              addressInsideTypes && Object.keys(addressInsideTypes).length > 0
                ? Number(addressInsideTypes.page)
                : currentPage
            }
            pages={
              addressInsideTypes && Object.keys(addressInsideTypes).length > 0
                ? Number(addressInsideTypes.totalPages)
                : 1
            }
            total={
              addressInsideTypes && addressInsideTypes.hasOwnProperty("total")
                ? addressInsideTypes.total
                : 0
            }
            offset={offset}
            onChangePage={(page) => setCurrentPage(page)}
            onChangeRange={(value) => {
              setOffset(value);
              reduxGetAddressInsideTypes({
                page: 1,
                offset: value,
                search: search,
              });
            }}
            defaultValue={search}
            onChangeSearch={(value) => {
              setSearch(value);
              reduxGetAddressInsideTypes({
                page: 1,
                offset: offset,
                search: value,
              });
            }}
          />
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        onEscapeKeyDown={handleClose}
        backdrop="static"
        keyboard={true}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rowEdited ? "Editar" : "Nuevo"} Tipo de Interior
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label htmlFor="code" className="form-label">
                Código
              </label>
              <input
                id="code"
                type="text"
                className={`form-control form-control-user ${
                  errors.code && "is-invalid"
                }`}
                {...register("code", { required: true })}
              />
              {errors.code && (
                <span className="invalid-feedback">El código es requerido</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Descripción
              </label>
              <input
                id="name"
                type="text"
                className={`form-control form-control-user ${
                  errors.name && "is-invalid"
                }`}
                {...register("name", { required: true })}
              />
              {errors.name && (
                <span className="invalid-feedback">
                  La Descripción requerida
                </span>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </ContentWrapper>
  );
};

const mapStateToProps = (state) => ({
  addressInsideTypes: state.addressInsideType.addressInsideTypes,
  addressInsideType: state.addressInsideType.addressInsideType,
  rowEdited: state.addressInsideType.rowEdited,
  rowDeleted: state.addressInsideType.rowDeleted,
  rowUpdated: state.addressInsideType.rowUpdated,
});

const mapDispatchToProps = (dispatch) => ({
  reduxGetAddressInsideTypes: (payload) =>
    dispatch({
      type: addressInsideTypeActions.FETCH_ADDRESSINSIDETYPE_REQUEST,
      value: payload,
    }),
  reduxPostAddressInsideType: (payload) =>
    dispatch({
      type: addressInsideTypeActions.CREATE_ADDRESSINSIDETYPE_REQUEST,
      value: payload,
    }),
  reduxGetAddressInsideType: (payload) =>
    dispatch({
      type: addressInsideTypeActions.READ_ADDRESSINSIDETYPE_REQUEST,
      value: payload,
    }),
  reduxDeleteAddressInsideType: (payload) =>
    dispatch({
      type: addressInsideTypeActions.DELETE_ADDRESSINSIDETYPE_REQUEST,
      value: payload,
    }),
  reduxPatchAddressInsideType: (payload) =>
    dispatch({
      type: addressInsideTypeActions.UPDATE_ADDRESSINSIDETYPE_REQUEST,
      value: payload,
    }),
  reduxResetAddressInsideTypeForm: () =>
    dispatch({
      type: addressInsideTypeActions.RESET_ADDRESSINSIDETYPE_FORM,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressInsideType);
